import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { CircularProgress, FormControl, MenuItem, Select } from '@mui/material';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { GetAllRegionsData } from '../../Redux/Actions/Regions_Action';
import { GetOneAreaData, UpdateOneAreaData } from '../../Redux/Actions/AreaActions';
import { Notify } from '../../Utility/Notify';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

export const UpdateArea = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const sidebarWidth = useSidebarWidth();

  const [userlogin, setuserlogin] = useState('');
  const [Areaname, setAreaname] = useState('');
  const [Region, setRegion] = useState('');
  const [loading, setloading] = useState(true);
  const [updateLoading, setUpdateLoading] = useState(false);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) != null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);

  const Areanamechange = (e) => {
    setAreaname(e.target.value);
  };

  const handleChange = (e) => {
    setRegion(e.target.value);
  };

  // ==================================================
  // get all regions
  useEffect(() => {
    const run = async () => {
      await dispatch(GetAllRegionsData());
      await dispatch(GetOneAreaData(id));
    };
    run();
  }, [dispatch, id]);

  const res_All_Regions = useSelector((state) => state.AllRegions.Region);
  let res_get_AllRegions_array = Array.isArray(res_All_Regions?.data) ? res_All_Regions.data : [];

  // ============================================================================
  // get one area to update
  const res_get_one_Area = useSelector((state) => state.AllArea.Area);

  let onearea = [];
  if (res_get_one_Area && res_get_one_Area.data) {
    onearea = res_get_one_Area.data;
  } else {
    onearea = [];
  }

  useEffect(() => {
    if (onearea) {
      setAreaname(onearea.Areaname);
      setRegion(onearea.Region ? onearea.Region._id : null);
    }
  }, [onearea]);

  // ======================================================
  // update Area
  const onsubmitupdate = async (e) => {
    e.preventDefault();
    if (!Areaname.trim()) return Notify('error', 'Please enter Area Name', 'error');
    setloading(true);
    setUpdateLoading(true);
    await dispatch(
      UpdateOneAreaData(id, {
        Areaname,
        Region,
      }),
    );
    setloading(false);
    setUpdateLoading(false);
  };

  const res_Update = useSelector((state) => state.AllArea.UpdateArea);

  useEffect(() => {
    if (loading === false) {
      if (res_Update && res_Update.status === 200) {
        Notify('success', 'Area Updated Successfully', 'success');
        setTimeout(() => navigate('/Areas'), 1200);
      } else {
        Notify('error', 'Failed to Update Area', 'error');
      }
      setloading(true);
    }
  }, [loading, res_Update, navigate]);

  // تحديد المسار المناسب بناءً على الدور
  const homeRoute =
    userlogin?.data?.role === 'Admin'
      ? '/AllLeads'
      : userlogin?.data?.role === 'Marketer'
        ? '/LeadsForMarketer'
        : '/';

  /* ─── shared styles ─── */
  const inputStyle = {
    width: '100%', padding: '13px 16px', borderRadius: '10px',
    border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    color: isDark ? '#f1f5f9' : '#0f172a',
    fontSize: '14px', outline: 'none', transition: 'all 0.2s',
    fontFamily: "'DM Sans',sans-serif", boxSizing: 'border-box',
  };
  const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: 700,
    letterSpacing: '0.08em', textTransform: 'uppercase',
    color: isDark ? '#9ca3af' : '#64748b', marginBottom: '8px',
  };
  const onFocus = (e) => {
    e.target.style.borderColor = '#2563eb';
    e.target.style.backgroundColor = isDark ? '#1a1f35' : '#ffffff';
    e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,0.12)';
  };
  const onBlur = (e) => {
    e.target.style.borderColor = isDark ? '#2d3248' : '#e2e8f0';
    e.target.style.backgroundColor = isDark ? '#151827' : '#f8fafc';
    e.target.style.boxShadow = 'none';
  };

  const selectSx = {
    borderRadius: '10px',
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    height: '48px',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '14px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: isDark ? '#2d3248' : '#e2e8f0',
      borderWidth: '1.5px',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#2563eb' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#2563eb',
      boxShadow: '0 0 0 3px rgba(37,99,235,0.12)',
    },
    '& .MuiSelect-select': {
      padding: '13px 16px',
      color: isDark ? '#f1f5f9' : '#0f172a',
    },
    '& .MuiSvgIcon-root': { color: isDark ? '#6b7280' : '#94a3b8' },
  };

  return (
    <div style={{
      position: 'fixed',
      top: '50px', left: sidebarWidth, right: 0, bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      fontFamily: "'DM Sans','Segoe UI',sans-serif",
      marginTop: '10px',
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding: '14px 28px',
        backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
        display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px',
      }}>
        <Link to={homeRoute} style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Home
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <Link to="/Areas" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Areas
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Update Area</span>
      </div>

      {/* ── Form ── */}
      <div style={{ padding: '28px 32px 48px' }}>
        <div style={{
          width: '100%', maxWidth: '720px',
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '20px', padding: '36px 40px',
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
        }}>

          {/* title */}
          <div style={{ marginBottom: '28px' }}>
            <h1 style={{
              fontSize: '22px', fontWeight: 700,
              color: isDark ? '#f1f5f9' : '#0d1b3e',
              margin: '0 0 4px', letterSpacing: '-0.4px',
            }}>
              Update Area
            </h1>
            <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', margin: 0 }}>
              Edit the area name and its region in the CRM database
            </p>
          </div>

          {/* Grid — 2 columns */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '8px' }}>

            {/* Area Name */}
            <div>
              <label style={labelStyle}>Area Name *</label>
              <input
                style={inputStyle}
                value={Areaname}
                onChange={Areanamechange}
                type="text"
                placeholder="e.g. Downtown, Marina"
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={(e) => { if (e.key === 'Enter') onsubmitupdate(e); }}
                autoFocus
              />
            </div>

            {/* Region Select */}
            <div>
              <label style={labelStyle}>Region</label>
              <FormControl fullWidth>
                <Select
                  value={Region || ''}
                  onChange={handleChange}
                  displayEmpty
                  sx={selectSx}
                >
                  <MenuItem value="" disabled>
                    <span style={{ color: isDark ? '#4b5563' : '#94a3b8', fontSize: '14px' }}>
                      Select a region
                    </span>
                  </MenuItem>
                  {res_get_AllRegions_array.map((item) => (
                    <MenuItem
                      key={item._id}
                      value={item._id}
                      sx={{ fontSize: '14px', fontFamily: "'DM Sans', sans-serif" }}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

          </div>

          {/* hint */}
          <p style={{ fontSize: '12px', color: isDark ? '#4b5563' : '#94a3b8', margin: '8px 0 0' }}>
            Enter the full area name and select the region it belongs to
          </p>

          {/* divider */}
          <div style={{ height: '1px', backgroundColor: isDark ? '#2a2f45' : '#e8eaf0', margin: '28px 0' }} />

          {/* buttons */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={!updateLoading ? onsubmitupdate : null}
              disabled={updateLoading}
              type="button"
              style={{
                flex: 1, padding: '14px 24px', borderRadius: '10px', border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff', fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: updateLoading ? 'not-allowed' : 'pointer',
                opacity: updateLoading ? 0.7 : 1,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                if (!updateLoading) {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)';
              }}
            >
              {updateLoading
                ? <><CircularProgress size={16} style={{ color: '#fff' }} /><span>Updating…</span></>
                : <><SyncAltIcon sx={{ fontSize: 17 }} /><span>Update Area</span></>}
            </button>

            <button
              type="button"
              onClick={() => navigate('/Areas')}
              style={{
                padding: '14px 28px', borderRadius: '10px',
                border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                backgroundColor: 'transparent',
                color: isDark ? '#9ca3af' : '#64748b',
                fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: 'pointer', transition: 'all 0.2s',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#4b5563' : '#94a3b8';
                e.currentTarget.style.color = isDark ? '#e5e7eb' : '#374151';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0';
                e.currentTarget.style.color = isDark ? '#9ca3af' : '#64748b';
              }}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};